import { STALE_CART_ERROR_MESSAGE } from "../constants/checkoutErrors";
import { getOrderCreatedTime } from "./sortUserOrders";

export { STALE_CART_ERROR_MESSAGE };

export const RECENT_ORDER_WINDOW_MS = 30 * 60 * 1000;

const TOTAL_MATCH_TOLERANCE = 0.01;

export const isStaleCartCheckoutError = (status, rawMessage) =>
  status === 404 &&
  String(rawMessage ?? "").trim() === STALE_CART_ERROR_MESSAGE;

/** The amount actually charged for an order, or null when unknown. */
export const getOrderChargedTotal = (order) => {
  const finalSum = Number(order?.finalSum);
  if (Number.isFinite(finalSum)) return finalSum;
  const totalSum = Number(order?.totalSum);
  if (!Number.isFinite(totalSum)) return null;
  return totalSum - (Number(order?.couponDiscount) || 0);
};

/**
 * Finds the most recently created order within the given time window whose
 * charged total matches the current checkout amount. Used to detect that a
 * "failed" checkout actually completed server-side; the total match guards
 * against mistaking an unrelated recent order (another tab/device, an earlier
 * purchase) for this checkout. Orders with no readable total never match when
 * an expectedTotal is given.
 */
export const findMatchingRecentOrder = (
  orders,
  { now = Date.now(), windowMs = RECENT_ORDER_WINDOW_MS, expectedTotal } = {},
) => {
  if (!Array.isArray(orders)) return null;

  let mostRecent = null;
  let mostRecentTime = -Infinity;
  for (const order of orders) {
    const time = getOrderCreatedTime(order);
    if (time == null || time < now - windowMs) continue;
    if (expectedTotal != null) {
      const charged = getOrderChargedTotal(order);
      if (
        charged == null ||
        Math.abs(charged - expectedTotal) > TOTAL_MATCH_TOLERANCE
      )
        continue;
    }
    if (time > mostRecentTime) {
      mostRecent = order;
      mostRecentTime = time;
    }
  }
  return mostRecent;
};
